import { Link } from 'react-router-dom';
import type { FC } from 'react';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

const VideoCard: FC<VideoCardProps> = ({ video }) => {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 棒棒TV免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        {/* Overlay on Hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-foreground-50 text-xs leading-relaxed line-clamp-3">
            {video.description}
          </p>
        </div>

        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 backdrop-blur-sm">
            <i className="ri-play-fill text-background-50 text-xl"></i>
          </div>
        </div>

        {/* Badges */}
        <div className="absolute top-2 left-2 flex gap-1.5">
          {video.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-950 whitespace-nowrap">
              最新
            </span>
          )}
          {video.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          )}
        </div>

        {/* Rating */}
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-semibold rounded bg-background-950/70 text-accent-400 whitespace-nowrap">
            {video.rating}
          </span>
        </div>

        {/* Status */}
        <div className="absolute bottom-2 right-2">
          <span className="px-2 py-0.5 text-xs rounded bg-background-950/70 text-foreground-200 whitespace-nowrap">
            {video.status}
          </span>
        </div>
      </div>

      {/* Info */}
      <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-1 mb-1">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{video.views ? `${(video.views / 10000).toFixed(0)}万次播放` : ''}</span>
        {video.views > 0 && <span>·</span>}
        <span>{video.updateInfo}</span>
      </div>
    </Link>
  );
};

export default VideoCard;